import React from 'react'
import PublicSiderXS from '../../Layouts/Sider/PublicSiderXS'
import TabletSlotForm from './TabletSlotForm'

export default function TabletCreateSlotPage ({ box, onFinishFailed, onFinish, loading }) {
  return (
    <>
      <PublicSiderXS />
      <TabletSlotForm box={box} onFinishFailed={onFinishFailed} onFinish={onFinish} loading={loading} />
    </>
  )
}
